import { render, staticRenderFns } from "./RiskCell.vue?vue&type=template&id=775bd842&scoped=true"
import script from "./RiskCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./RiskCell.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RiskCell.vue?vue&type=style&index=0&id=775bd842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775bd842",
  null
  
)

export default component.exports